import React from "react";
import { Text } from "@showitinc/showit-wc";
import config from "../config/app";
import UserActions from "../actions/UserActions";

const FEATURE = "feature";
export const SAFARI_SUPPORT = "safari";

/**
 * Runs the notifyCallback once.
 * @param {() => void} notifyCallback
 * @returns {() => void}
 */
const notifier = (notifyCallback) => {
  let notified = false;

  return () => {
    if (!notified) {
      notifyCallback();
      notified = true;
    }
  };
};

export const FEATURE_MAP = {
  [SAFARI_SUPPORT]: {
    beta: true,
    check: () => config.browser === "safari",
    message: (
      <Text style={{ cursor: "default" }}>
        You’re trying out the Beta version of Showit for Safari. For full compatibility consider
        using in Chrome.
        <br />
        <a
          href="https://learn.showit.com/en/articles/11350338-showit-for-safari"
          style={{ cursor: "pointer" }}
          target="_blank"
        >
          Learn more or report a problem…
        </a>
      </Text>
    ),
    name: SAFARI_SUPPORT,
    notify: notifier(() =>
      UserActions.trackEvent({
        event: `${FEATURE}-${SAFARI_SUPPORT}`,
      })
    ),
  },
};
